<script setup lang="ts">
import { ref } from 'vue';
import { type ShiftsUniqueDates } from '@/api/charges';

interface Props {
  modelValue: boolean;
  dates: ShiftsUniqueDates | null;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

const copySnackbarAlert = ref(false);
const copiedText = ref('');

const careers = {
  'caregiver': 'Cuidador/a',
  'nurseTechnician': 'TENS',
  'nurse': 'Enfermero/a',
  'auxiliaryNurse': 'Auxiliar de enfermería',
  'occupationalTherapist': 'Terapeuta ocupacional',
  'kinesiologist': 'Kinesiólogo/a',
  'phonoaudiologist': 'Fonoaudiólogo/a',
  'doctor': 'Médico',
  'podologist': 'Podólogo/a',
  'psychologist': 'Psicólogo/a',
  'massagist': 'Masajista',
  'personal_assistant': 'Acompañante',
  'dietitian': 'Nutricionista',
  'midwife': 'Matrona',
  'supervising_nurse': 'Enfermero/a Supervisor/a',
};

function copyCareerDates(career: string) {
  if (props.dates && props.dates[career]) {
    const textToCopy = props.dates[career];
    navigator.clipboard.writeText(textToCopy);
    copiedText.value = textToCopy;
    copySnackbarAlert.value = true;
    emit('update:modelValue', false);
  }
}

function getFormattedCareerName(career: string): string {
  if (career === 'all') {
    return 'Todas las fechas';
  }

  return career === 'empty' ? 'Sin especialidad' : careers[career as keyof typeof careers];
}
</script>
<template>
  <v-dialog
    :model-value="modelValue"
    max-width="500"
    @update:model-value="(value: boolean) => emit('update:modelValue', value)"
  >
    <v-card v-if="dates">
      <v-card-title class="pb-2 text-h5">
        Fechas de turnos por especialidad
      </v-card-title>
      <v-card-subtitle class="pb-0">
        Selecciona una especialidad para copiar sus fechas
      </v-card-subtitle>
      <v-card-text>
        <v-list>
          <v-list-item
            v-for="(dateValue, careerKey) in dates"
            :key="String(careerKey)"
            :title="getFormattedCareerName(String(careerKey))"
            @click="copyCareerDates(String(careerKey))"
          >
            <template #append>
              <v-icon
                icon="mdi-content-copy"
                size="small"
              />
            </template>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text="Cerrar"
          @click="emit('update:modelValue', false)"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-snackbar
    v-model="copySnackbarAlert"
    :timeout="2000"
    color="primary"
    rounded="pill"
  >
    Fechas copiadas al portapapeles con éxito!
  </v-snackbar>
</template>
